import { compile, pathToRegexp } from 'path-to-regexp'
import { replace } from 'connected-react-router'

import debounce from '@doveconviene/sf-web-js-sdk/debounce'

import {
  ON_ENRICHMENT_DRAWER_ACTION,
  VIEWER_BROWSE,
} from '../../actions'

import {
  selectActiveEnrichment,
  selectRouterLocation,
  selectViewerFlyerId,
} from '../../selectors'

import { takeEvery } from '../helpers'

import { flyerPath, flyerPathV2 } from '../../../routes'
import { DRAWER_ACTIONS } from '../../../utils/consts'

const onViewerBrowse = ({ getState, dispatch }, { payload }) => {
  const state = getState()

  const { search, pathname } = selectRouterLocation(state)

  const flyerId = selectViewerFlyerId(state)
  const { currentPages: [flyerPage] } = payload.pagesData

  if (!flyerPage) return

  const pathTo = compile(pathname.includes('v2') ? flyerPathV2 : flyerPath)

  dispatch(replace({
    pathname: pathTo({ flyerId, flyerPage }),
    search,
  }))
}

const onEnrichmentDrawerAction = ({ getState, dispatch }, { payload: { fid, fgid, action } }) => {
  const state = getState()
  const { search, pathname } = selectRouterLocation(state)
  const routePath = pathname.includes('v2') ? flyerPathV2 : flyerPath
  const parsedPathname = pathToRegexp(routePath).exec(pathname)
  const [, currFlyerId, currFlyerPage = 1] = parsedPathname

  const pathTo = compile(routePath)
  const flyerGib = selectActiveEnrichment(state)

  const destPathname = action !== DRAWER_ACTIONS.close
    ? pathTo({ flyerId: fid, flyerPage: flyerGib.flyerPage, flyerGibId: fgid })
    : pathTo({ flyerId: currFlyerId, flyerPage: currFlyerPage })

  dispatch(replace({
    pathname: destPathname,
    search,
  }))
}

export default [
  takeEvery(VIEWER_BROWSE, debounce(onViewerBrowse, 500)),
  takeEvery(ON_ENRICHMENT_DRAWER_ACTION, debounce(onEnrichmentDrawerAction, 500)),
]
